import styled from "styled-components"
import AdminMenu from "./AdminMenu"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {Button} from "../styles/Button";
import PageHeader from "../components/PageCloseButton";
import { toTitleCase, normalize, normalizeNoSpaces } from "../Helpers/stringTitlecase.js";


const CreateSubcategory=()=>{

     const [data, setData] = useState({
            value:"",
            label:"",
            category: "",
      })

      const [categories, setCategories] = useState([]);

      const navigate=useNavigate();

      
  useEffect(() => {
    const fetchCategories = async () => {
    try {
    const res = await fetch(
    "http://localhost:8080/api/products/categories"
    );
    const result = await res.json();
    setCategories(result);
    } catch (error) {
    toast.error("Failed to load categories");
    }
    };

    fetchCategories();
    }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setData((prev) => ({
    ...prev,
    [id]: toTitleCase(value),
    }));
    };
  
const [subcategories, setSubcategories] = useState([]);

useEffect(() => {
  const fetchCategories = async () => {
    try {
      // const res = await fetch("http://localhost:8080/api/products/categories");
      const res = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/api/products/categories`);
      const result = await res.json();
      setCategories(result);
    } catch (error) {
      toast.error("Failed to load categories");
    }
  };

  const fetchSubcategories = async () => {
    try {
      // const res = await fetch("http://localhost:8080/api/products/subcategories");
      const res = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/api/products/subcategories`);
      const result = await res.json();
      setSubcategories(result);
    } catch (error) {
      toast.error("Failed to load subcategories");
    }
  };

  fetchCategories();
  fetchSubcategories();
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    
      
const duplicate = subcategories.find(
  (sub) =>
    normalize(sub.value) === normalize(data.value) ||
    normalize(sub.label) === normalize(data.label) ||
    normalizeNoSpaces(sub.value) === normalizeNoSpaces(data.value) ||
    normalizeNoSpaces(sub.label) === normalizeNoSpaces(data.label)
);

      if (duplicate) {
      toast.error("Subcategory already exists!");
      return;
      }
      
    try{
    console.log("Submitting data:", data);
    
    // const response = await fetch('http://localhost:8080/api/products/subcategories', {
    const response = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/api/products/subcategories`, {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    });
      
      
    if (!response.ok) {
      const errorData = await response.json();
      console.log("BACKEND ERROR:", errorData);
      toast.error(errorData.message || "Subcategory creation failed");
      return;
        }
      
     const result = await response.json();
     toast.success('Subcategory added successfully');
     navigate('/productform')

            // console.log('Product added:', result);
    }
    catch(error) {
            // console.error('form', error);
            toast.error('Subcategory failed')
    }
    };

  return(
    <Wrapper>
        <div className="grid grid-two-column">
            <AdminMenu/>
          <div className="main-container">
            <div className="category">
              <form onSubmit={handleSubmit} autoComplete="off">
              <PageHeader title="Create SubCategory" />
                <div className="product-container">                        
                    <label htmlFor="value">Subcategory Value</label>
                      <input id="value" 
                      value={data.value}
                      onChange={handleChange} 
                      placeholder="value" 
                      />
               
                    <label htmlFor="label">Subcategory Label</label>
                      <input id="label" 
                      value={data.label}
                      onChange={handleChange} 
                      placeholder="label" 
                      />
                   
                     <label htmlFor="categoryId">Select Category</label>
                        <select
                        id="category"
                        value={data.category}
                        onChange={handleChange}
                        >
                        <option value="">-- Select Category --</option>
                        {categories.map((cat) => (
                        <option key={cat._id} value={cat._id}>
                        {cat.label}
                        </option>
                        ))}
                        </select>
                       
                  </div>
                <div className="product-container">
                    <Button type="submit">Add</Button>
                </div>
              </form>
            </div>
          </div>
        </div>
    </Wrapper>
    )
}
const Wrapper=styled.section`
  
.grid-two-column{
  grid-template-columns:2fr 8fr;
  }
    
.main-container {
  justify-content: centre;
  align-items: center;
  padding : 3rem;
  }
  
.category{
  display: flex;
  flex-direction: column;
  width: 40%;
  margin-top: 2rem;
  padding: 3rem;
  border-radius: 0.8rem;
  background-color:${({ theme }) => theme.colors.bg};
  box-shadow: 0 2px 10px rgba(0,0,0,0.3);
  }

.product-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 1rem;
  padding: 3rem;  
 }
 

 @media (max-width: ${({ theme }) => theme.media.mobile}){
 
 .grid-two-column {
    grid-template-columns: 1fr;
    }

  .container {
    margin: 0rem;
   }
  
  .category {
    width: 1000%;
    max-width: 97%;
    margin-top: 1rem;
     padding: 1rem;
    }

  .product-container {
    Padding: 2rem;   
    gap: 0.5rem;
     padding: 1rem;
    }
    
}`;
export default CreateSubcategory